<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Nova sugestão</span>
      </h1>
      <div>
        <PrimaryButton @click="submit()" class="px-5" icon="fa-solid fa-paper-plane">Enviar</PrimaryButton>
      </div>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div v-if="!loading" class="card">
      <div class="p-4">
        <form>
          <div class="row">
            <div class="col-12 mb-3">
              <InputText label="Título" v-model="suggestion.title" :error="formErrors.title" maxlength="100" />
            </div>

            <div class="col-12 mb-3">
              <TextArea label="Sugestão" v-model="suggestion.content" :error="formErrors.content" maxlength="2000" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import TextArea from '@/components/TextArea.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { useSuggestionStore } from '@/stores/SuggestionStore'
import { inject, onMounted, ref } from 'vue';
import { useToast, TYPE } from "vue-toastification";
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import {errorFormat} from "@/utils/errorFormat";

const toast = useToast();

const loader = inject('$loader');
const loading = ref(true);

const formErrors = ref({});

const suggestionStore = useSuggestionStore();
const { suggestion } = storeToRefs(suggestionStore);

const route = useRoute();
const router = useRouter();

onMounted(async () => {
  suggestionStore.suggestion = {};


  const id = route.params.id;
  if(id){
    loader.show();
    await suggestionStore.getPage(id);
    loader.hide();
  }

  loading.value = false;
});

const submit = async() => {
    let params = ref({
      title: suggestionStore.suggestion.title,
      content: suggestionStore.suggestion.content,
    });

    loader.show();
    formErrors.value = {};


    const formResult = await suggestionStore.addSuggestion(params.value);
    if(formResult.success){
      toast('Sugestão enviada', { type: TYPE.SUCCESS, timeout: 6000 });
      router.push({ name: 'suggestions'});
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
    }

    loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}
</style>